import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  Optional,
  ViewEncapsulation,
} from '@angular/core';
import { MOBILE_LOCK_MODAL_DATA } from './mobile-lock-modal.token';
import { MobileLockModalData } from './mobile-lock.types';

@Component({
  selector: 'lp2-mobile-lock',
  templateUrl: './mobile-lock.component.html',
  styleUrls: ['./mobile-lock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'mobile-lock',
  },
})
export class MobileLockComponent implements OnInit {
  public translationKeys = this.MobileLockModalData.translationKeys;
  public studentName = this.MobileLockModalData.studentName;
  public url: string;

  constructor(
    @Inject(MOBILE_LOCK_MODAL_DATA) private MobileLockModalData: MobileLockModalData,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.url = this.MobileLockModalData.buildDeepLinkUrl();
    this.cdr.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-lock/mobile-lock.component.ts